<div class="header-container" id="homeHeader">
  <div id="fadeText">
    <div>
      <h1 class="cursive index-header-fade cursor-scale">
        <span>
          Living a Long Life
          <sub class="trademark"> &trade; </sub>
        </span>
      </h1>

      <h2 class="cursor-scale small">PLANNING FOR LONGEVITY</h2>
    </div>
  </div>

  <div #mobileImg class="zoominout mobile-image" [ngStyle]="{ 'background-image': 'url(' + env.google.bucket + '/assets/home-page/agingplan/WebPage_Header_Couple.jpg)' }"></div>

  <div class="header-parallax">
    <div class="parallax__group">
      <div #index_header id="index-header" class="zoominout parallax__layer parallax__layer--base"></div>

      <div
        [ngStyle]="{ 'background-image': 'url(' + env.google.bucket + '/assets/home-page/agingplan/WebPage_Header_OverlayCouple_Desktop_3840x2160.png)' }"
        id="index-header-overlay"
        class="parallax__layer parallax__layer--fore"></div>
    </div>
  </div>
</div>

<div id="founded" class="gray-bg index-about">
  <div class="container lucid-width">
    <div class="brand-logo large d-flex justify-content-center">
      <img style="left: 8px" [src]="env.google.bucket + '/assets/agingplan/logo/AgingPlan_LightBackground.svg'" alt="AgingPlan Logo" />
    </div>
    <p>
      FOUNDED IN 1988, our sole focus is, and always has been, Long-Term Care planning. Because we are committed to this one area of focus, we are able to offer a level of service and expertise that
      is unique. We strive to be the best at what we do. Since Long-Term Care Planning is ALL we do, we are able to invest all of our energy into this goal.
    </p>
  </div>
</div>

<div class="woman-on-beach-wrapper" [Parallax]="4">
  <div [ngStyle]="{ 'background-image': 'url(' + env.google.bucket + '/assets/home-page/agingplan/WebPage_FullWidthImage_Woman.jpg)' }" class="bg woman-on-beach parallax"></div>
</div>

<div class="container lucid-width white-bg">
  <div class="index-text-on-white">
    <p>
      Our longevity and specialty in the Long-Term Care Insurance market has enhanced our depth of understanding in this market, from the carriers that offer insurance product solutions to the needs
      of families at the time of a care need. We have the knowledge and experience to assist clients in making appropriate and well-thought-out planning decisions.
    </p>

    <div
      class="text-center read-more cursor-scale small"
      data-aos-once="true"
      data-aos-offset="-200"
      data-aos-easing="ease-out"
      data-aos-duration="500"
      data-aos-anchor-placement="bottom-center"
      data-aos="fade-in">
      <a (click)="openReadMore()"> READ MORE </a>
    </div>
  </div>
</div>

<div id="index-family-in-field" [Parallax]="4">
  <div [ngStyle]="{ 'background-image': 'url(' + env.google.bucket + '/assets/home-page/agingplan/WebPage_FullWidthImage_Family.jpg)' }" class="bg parallax"></div>

  <div data-aos-once="false" data-aos-easing="ease-out" data-aos-offset="-100" data-aos-duration="1000" data-aos-anchor-placement="top-center" data-aos="fade-up">
    <h2 class="cursor-scale small">PLAN WITH THE INTENT OF</h2>

    <h1 class="cursive cursor-scale">Protecting Others</h1>
  </div>
</div>

<popover-content-outlet #popover_read_more [hide_navbar]="true">
  <app-read-more></app-read-more>
</popover-content-outlet>
